var component = require('../../../lib/js/component.js');

function FieldDate() {
    this.initialize = function (element) {
        var $input = $(element);

        $input.prop('readonly', false);

        if (!$input.attr('id')) {
            $input.attr('id', $input.attr('name'));
        }

        $input.datepicker({
            minDate: $input.closest("form").data("minDate"),
            maxDate: $input.closest("form").data("maxDate"),
            showAnim: ""
        });

        $input.on("input", this.formatDateLive.bind(this));
        $input.on("blur", this.validateAndFormatDate.bind(this));
    };

    this.formatDateLive = function (event) {
        var $input = $(event.target);
        var digits = $input.val().replace(/\D/g, '').substring(0, 8);
        var out = digits;

        if (digits.length > 2 && digits.length <= 4) {
            out = digits.substring(0, 2) + '/' + digits.substring(2);
        } else if (digits.length > 4) {
            out = digits.substring(0, 2) + '/' + digits.substring(2, 4) + '/' + digits.substring(4);
        }

        $input.val(out);
    };

    this.isValidDateString = function (dateStr) {
        if (!dateStr) return false;
        var regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
        if (!regex.test(dateStr)) return false;

        var parts = dateStr.split('/');
        var mm = parseInt(parts[0], 10);
        var dd = parseInt(parts[1], 10);
        var yyyy = parseInt(parts[2], 10);

        var date = new Date(yyyy, mm - 1, dd);
        return date.getFullYear() === yyyy && (date.getMonth() + 1) === mm && date.getDate() === dd;
    };

    this.validateAndFormatDate = function (event) {
        var $input = $(event.target);
        var val = $input.val().trim();
        var $fieldWrapper = $input.closest('.Field');
        var errorId = $input.attr("aria-describedby");

        if (!val) {
            $fieldWrapper.removeClass("has-error");
            $input.removeAttr("aria-invalid");
            if (errorId) $("#" + errorId).text("").addClass("sr-only");
            return;
        }

        var digits = val.replace(/\D/g, "");
        if (digits.length === 8) {
            val = digits.substring(0,2) + "/" +
                  digits.substring(2,4) + "/" +
                  digits.substring(4);
        }

        if (!this.isValidDateString(val)) {
            $fieldWrapper.addClass("has-error");
            $input.attr("aria-invalid", "true");
            if (errorId) $("#" + errorId).text("Invalid Date Format. Please enter mm/dd/yyyy.").removeClass("sr-only");
            return;
        }

        // ES5-compatible parsing
        var parts = val.split('/');
        var mm = parseInt(parts[0], 10);
        var dd = parseInt(parts[1], 10);
        var yyyy = parseInt(parts[2], 10);
        var date = new Date(yyyy, mm - 1, dd);

        $input.val(
            ('0' + (date.getMonth() + 1)).slice(-2) + '/' +
            ('0' + date.getDate()).slice(-2) + '/' +
            date.getFullYear()
        );

        $fieldWrapper.removeClass("has-error");
        $input.removeAttr("aria-invalid");
        if (errorId) $("#" + errorId).text("").addClass("sr-only");
    };
}

module.exports = component(FieldDate);